import { useCallback, useState } from "react";
import {
  validarCupon,
  aplicarCupon,
  removerCupon,
} from "../../../services/backend/cotizacionService";
import logger from "../../../shared/utils/logger";

const useCoupon = ({ cotizacionId, onRefreshCheckoutSummary }) => {
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponMessage, setCouponMessage] = useState(null);
  const [couponMessageType, setCouponMessageType] = useState(null);

  const handleApplyCoupon = useCallback(async () => {
    const code = String(couponCode || "").trim();
    if (!code) {
      setCouponMessage("Ingrese un código válido.");
      setCouponMessageType("error");
      return;
    }

    if (!cotizacionId) {
      setCouponMessage("Sin cotización activa.");
      setCouponMessageType("error");
      return;
    }

    setCouponLoading(true);
    setCouponMessage(null);
    setCouponMessageType(null);

    try {
      const validarResponse = await validarCupon(code);

      if (validarResponse?.valido === false) {
        setCouponMessage(
          validarResponse?.mensaje || "Código de cupón inválido."
        );
        setCouponMessageType("error");
        return;
      }

      await aplicarCupon({ id_cotizacion: cotizacionId, codigo: code });

      setCouponApplied(true);
      setCouponMessage("Cupón aplicado correctamente.");
      setCouponMessageType("success");

      if (onRefreshCheckoutSummary) {
        await onRefreshCheckoutSummary(cotizacionId);
      }
    } catch (error) {
      logger.error("Error al aplicar cupón:", error);
      setCouponMessage(
        error?.message || "No fue posible aplicar el cupón."
      );
      setCouponMessageType("error");
    } finally {
      setCouponLoading(false);
    }
  }, [couponCode, cotizacionId, onRefreshCheckoutSummary]);

  const handleRemoveCoupon = useCallback(async () => {
    if (!cotizacionId) return;

    setCouponLoading(true);
    setCouponMessage(null);
    setCouponMessageType(null);

    try {
      await removerCupon({ id_cotizacion: cotizacionId });

      setCouponApplied(false);
      setCouponCode("");
      setCouponMessage(null);
      setCouponMessageType(null);

      if (onRefreshCheckoutSummary) {
        await onRefreshCheckoutSummary(cotizacionId);
      }
    } catch (error) {
      logger.error("Error al remover cupón:", error);
      setCouponMessage(
        error?.message || "No fue posible quitar el cupón."
      );
      setCouponMessageType("error");
    } finally {
      setCouponLoading(false);
    }
  }, [cotizacionId, onRefreshCheckoutSummary]);

  return {
    couponCode,
    couponApplied,
    couponLoading,
    couponMessage,
    couponMessageType,
    setCouponCode,
    handleApplyCoupon,
    handleRemoveCoupon,
  };
};

export default useCoupon;
